import React, { useState } from 'react'
import './tracking.style.css'
import { useTranslation } from 'react-i18next'
import ArrowDown from '../../../assets/svgs/ArrowDown'
import { Button, Skeleton, Space } from 'antd'
import { callLink, DAASPHONE, TRACKING_URL } from '../../../common/consts.common'
import PhoneSvg from '../../../assets/svgs/Phone'
import ShippingStatusItem from '../../organism/shippingItem/ShippingStatusItem'
import { useShippingHistories } from '../../../api/useShippingHistories'
import { useNavigate, useParams } from "react-router-dom";
import { useShippingInfo } from "../../../api/useShippingInfo";
import { showMessageWithTitle } from "../../../common/message";
import { maskingName } from "../../../common/fns";

const STATUS_MISSING = [
  "CANCEL_BEFORE_CLUSTER",
  "CANCEL_B4_OUTDELIVERY",
]
export const TrackingScreen = () => {
  const { tracking } = useParams();
  const { shipping: shippingInfo } = useShippingInfo(tracking)
  const { t } = useTranslation(['tracking'])
  const [active, setActive] = useState(false)
  const { result } = useShippingHistories(tracking, t)
  const navigate = useNavigate()

  function handleReturn() {
    if (!shippingInfo?.tracking_number_return) {
      navigate(TRACKING_URL + `${tracking}/reqReturn`)
    } else {
      showMessageWithTitle(t('There is a return in progress'))
    }
  }

  let statusLabel = "", statusH2 = "", statusInfo = "";
  if (!shippingInfo) {
    statusLabel = t('-');
  } else if (STATUS_MISSING.includes(shippingInfo?.status) && !!shippingInfo.metadata) {
    if (shippingInfo.metadata?.cancel?.reason && shippingInfo.metadata.cancel.reason.includes("LOST")) { //택배사 문제일 때
      statusLabel = t('missing.courier');
      statusH2 = t('status.missing.courier');
      statusInfo = t('status.sub.missing.courier');
    } else if (shippingInfo.metadata?.cancel?.reason && shippingInfo.metadata.cancel.reason.includes("SELLER_REQUEST") && shippingInfo.metadata.cancel.reason_text?.includes("분실")) {
      //회주사 요청일 때
      statusLabel = t('missing.mall');
      statusH2 = t('status.missing.mall');
      statusInfo = t('status.sub.missing.mall');
    } else {
      statusLabel = t(shippingInfo?.status || '-');
      statusH2 = t('status.' + shippingInfo?.status, {
        hub: shippingInfo?.hub_name || 'hub',
        unit: shippingInfo?.unit_name || "unit",
        shop: shippingInfo?.shop_name || "shop",
      })
      statusInfo = t('status.sub.' + shippingInfo?.status);
    }
  } else {
    statusLabel = t(shippingInfo.status || '-');
    statusH2 = t('status.' + shippingInfo.status, {
      hub: shippingInfo?.hub_name || 'hub',
      unit: shippingInfo?.unit_name || "unit",
      shop: shippingInfo?.shop_name || "shop",
    })
    statusInfo = t('status.sub.' + shippingInfo.status);
  }

  const statusNode = (
    <div className={'round-cntr column align-center'}>
      <div className={'tracking-sts body bold white'}>{statusLabel}</div>
      {!shippingInfo ? (
        <Skeleton title={false} paragraph={{ rows: 2, className: 'column align-center' }}/>
      ) : (
        <div className={'column align-center'}>
          <div className={'h2'}>
            {statusH2}
          </div>
          <div className={'tracking-info small medium black45'}>{statusInfo}</div>
        </div>
      )}
    </div>
  )

  const Panel = (
    <div className={'column ' + (active ? 'tracking-panel-active' : 'tracking-panel')}>
      <div className={'row'}>
        <div className={'tracking-label body bold black-85'}>{t('pickup.date')}</div>
        <div className={'tracking-val body medium black45'}>{result?.formattedDate}</div>
      </div>
      <div className={'row'}>
        <div className={'tracking-label body bold black-85'}>{t('sender.name')}</div>
        <div className={'tracking-val body medium black45'}>{shippingInfo?.shop_name}</div>
      </div>
      <div className={'row'}>
        <div className={'tracking-label body bold black-85'}>{t('sender.addr')}</div>
        <div className={'tracking-val body medium black45'}>{shippingInfo?.shop_address}</div>
      </div>
    </div>
  )

  const productNode = (
    <div className={'column'}>
      <span className={'tracking-title body1'}>{t('product.title')}</span>
      <div className={'round-cntr'}>
        <div className={'row'}>
          <div className={'tracking-label body bold black-85'}>{t('tracking.number')}</div>
          <div className={'tracking-val body medium black45'}>{tracking}</div>
        </div>
        <div className={'row'}>
          <div className={'tracking-label body bold black-85'}>{t('receiver')}</div>
          <div className={'tracking-val body medium black45'}>{maskingName(shippingInfo?.receiver_name, true)}</div>
        </div>
        <div className={'row'}>
          <div className={'tracking-label body bold black-85'}>{t('destination')}</div>
          <div className={'tracking-val body medium black45'}>{shippingInfo?.receiver_address}</div>
        </div>
        <div className={'row'}>
          <div className={'tracking-label body bold black-85'}>{t('product.name')}</div>
          <div className={'tracking-val body medium black45'}>{shippingInfo?.product_info}</div>
        </div>
        {Panel}
        <Button block size={"middle"} className={'tracking-btn-detail'} data-cy={'collapse'}
                onClick={() => setActive(act => !act)}>
                    <span
                      className={'tracking-btn-txt body medium black45'}>{active ? t('Close detail') : t('Show detail')}</span>
          <ArrowDown rotate={active ? 180 : 0}/>
        </Button>
      </div>
    </div>
  )

  const deliveryNode = (
    <div className={'column'}>
      <span className={'tracking-title body1'}>{t('delivery.title')}</span>
      <div className={'round-cntr'}>
        <div className={'row'}>
          <div className={'tracking-del-date body bold black-85'}>{t('delivery.detail')}</div>
          <div className={'tracking-del-sts body bold black-85'}>{t('delivery.status')}</div>
        </div>
        {!!result.histories &&
          result.histories.map((s, index) => (
            <ShippingStatusItem
              key={'sitem' + index}
              {...s}
              photo={shippingInfo?.photo}
              last={index === result.histories.length - 1}
            />
          ))}
      </div>
    </div>
  )

  const daasNode = (
    <div className={'column'}>
      <span className={'tracking-title body1'}>{t('daas.title')}</span>
      <div className={'round-cntr'}>
        <div className={'row'}>
          <div className={'tracking-label body bold black-85'}>{t('daas.company')}</div>
          <div className={'tracking-val'}>
            <div className={'body medium black45 flex'}>{t('daas.name')}</div>
            <Button data-cy={'callLink'} shape={'circle'} className={'tracking-btn'}
                    href={callLink(DAASPHONE)}>
              <PhoneSvg/>
            </Button>
          </div>
        </div>
      </div>
    </div>
  )

  return (
    <Space direction={'vertical'} size={20}>
      {statusNode}
      {productNode}
      {deliveryNode}
      {daasNode}
      {shippingInfo?.show_return_button_tracking_app && !shippingInfo.tracking_number_return && shippingInfo?.status === 'DELIVERYCOMPLETE' && (
        <>
          <div className={'floating-btn-margin'}/>
          <Button type={'primary'} size={"large"} className={"floating-btn"} onClick={handleReturn}>
            {t('Apply returning')}
          </Button>
        </>
      )}
    </Space>
  )
}
